/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type PortfolioItemsAction = "ADD" | "EDIT" | "REMOVE" | "REORDER" | "%future added value";
export type PortfolioType = "CART" | "HEART" | "%future added value";
export type ModifyPortfolioItemsInput = {
    readonly action: PortfolioItemsAction;
    readonly endPortfolioItemId?: string | null;
    readonly itemsIds?: ReadonlyArray<string | null> | null;
    readonly note?: string | null;
    readonly portfolioItemsIds?: ReadonlyArray<string | null> | null;
    readonly portfolioId?: string | null;
    readonly portfolioType?: PortfolioType | null;
    readonly startPortfolioItemId?: string | null;
    readonly targetPortfolioItemId?: string | null;
    readonly userId: string;
    readonly clientMutationId?: string | null;
};
export type ModifyPortfolioFolderItemsMutationVariables = {
    readonly input: ModifyPortfolioItemsInput;
};
export type ModifyPortfolioFolderItemsMutationResponse = {
    readonly modifyPortfolioItems: {
        readonly portfolio: {
            readonly id: string;
        } | null;
    } | null;
};
export type ModifyPortfolioFolderItemsMutation = {
    readonly response: ModifyPortfolioFolderItemsMutationResponse;
    readonly variables: ModifyPortfolioFolderItemsMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "ModifyPortfolioItemsInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "modifyPortfolioItems",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ModifyPortfolioItemsPayload",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "portfolio",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PortfolioV2",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "id",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "ModifyPortfolioFolderItemsMutation",
            "type": "Mutations",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "ModifyPortfolioFolderItemsMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "ModifyPortfolioFolderItemsMutation",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/ModifyPortfolioFolderItemsMutation",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '8f51615d6e2efb6fcc67b239c6bdb7c5';
export default node;
